const common = {
  // Navbar
  "nav.philosophy": "Philosophie",
  "nav.products": "Produkte",
  "nav.buy": "Kaufen",
  "nav.contact": "Kontakt",
  "nav.more": "Mehr",
  "nav.medicalOrigin": "Medizinische Herkunft",
  "nav.bodyAesthetics": "Körperästhetik",
  "nav.scienceDesign": "Wissenschaft & Design",
  "nav.quality": "Qualität",
  "nav.trust": "Vertrauen",
  "nav.journal": "Journal",

  // Hero Section
  "hero.title1": "Im Gleichgewicht",
  "hero.title2": "mit dem Körper.",
  "hero.cta": "Philosophie entdecken",
  "hero.description":
    "Ein deutscher medizinischer Ansatz zur Körperausrichtung, Haltung und täglichen Gesundheitspflege.",
  "hero.founded": "Gegründet in Deutschland, 2018",

  // Brand Philosophy Section
  "brand.label": "(Markenphilosophie)",
  "brand.title1": "Wahre Körperästhetik",
  "brand.title2": "Ist keine aggressive Veränderung.",
  "brand.desc1":
    "DR. MAGICAL glaubt, dass echte Körperästhetik aus dem Verständnis von Struktur, Haltung und täglichen Gewohnheiten entsteht — nicht aus radikalen Eingriffen.",
  "brand.desc2":
    "Durch nicht-chirurgische, physikalische Korrekturmethoden unterstützen wir die natürliche Ausrichtung des Körpers und das langfristige Gleichgewicht.",
  "brand.learnMore": "Mehr erfahren",

  // German Medical Origin Section
  "medical.title": "Medizinische Einsicht, Deutsche Präzision.",
  "medical.subtitle":
    "Verwurzelt in medizinischer Strenge und Ingenieurdisziplin",
  "medical.origin": "Medizinische Herkunft, Deutschland",
  "medical.precision": "Ingenieurs-Präzision",
  "medical.structure": "Produktstruktur & Design",

  // Non-Invasive Section
  "noninvasive.title": "Ein nicht-invasiver Ansatz zur Körperausrichtung",
  "noninvasive.subtitle":
    "Unsere Produkte arbeiten mit dem Körper, nicht gegen ihn — sie stellen das Gleichgewicht durch Beständigkeit statt Intensität wieder her.",
  "noninvasive.feature1.title": "Keine Operation. Keine Abhängigkeit.",
  "noninvasive.feature1.desc":
    "Sichere und natürliche Methoden, die die Integrität Ihres Körpers respektieren.",
  "noninvasive.feature2.title": "Sanfte physische Führung",
  "noninvasive.feature2.desc":
    "Keine erzwungene Korrektur, sondern unterstützende Ausrichtung über die Zeit.",
  "noninvasive.feature3.title": "Für langfristige Nutzung konzipiert",
  "noninvasive.feature3.desc":
    "Nachhaltige Lösungen, die Teil Ihrer täglichen Routine werden.",

  // Products Section
  "products.title": "Tägliche Pflegelösungen",
  "products.subtitle": "Entwickelt für Komfort, Präzision und Diskretion",
  "products.viewAll": "Alle Produkte ansehen",
  "products.viewDetails": "Details ansehen",
  "products.product1.name": "Mundatmungskorrektur",
  "products.product1.desc": "Für verbesserte Atemmuster während des Schlafs",
  "products.product2.name": "Nasenunterstützung & Luftstrom",
  "products.product2.desc": "Sanfte Unterstützung für optimale Nasenatmung",
  "products.product3.name": "Schlaf- & Lärmmanagement",
  "products.product3.desc": "Für erholsamen Schlaf und Lärmreduzierung",

  // Design Section
  "design.title1": "Entwickelt für Komfort,",
  "design.title2": "Präzision und Diskretion",
  "design.desc1":
    "Von der Materialauswahl bis zum Strukturdesign wird jedes DR. MAGICAL Produkt entwickelt, um Funktionalität mit Tragekomfort in Einklang zu bringen.",
  "design.desc2": "Unsichtbar beim Tragen. Mühelos im Alltag.",

  // Trust Section
  "trust.title1": "Offizielle Kanäle.",
  "trust.title2": "Langfristiges Vertrauen.",
  "trust.cta": "Bezugsquellen",
  "trust.description":
    "Wir erreichen Konsumenten weltweit und verändern das Leben von Hunderten Millionen Konsumenten. Seit dem Markteintritt arbeitet DR. MAGICAL mit führenden Plattformen wie Amazon, Wish, Noon, Tmall Global, Alibaba Health, JD Supermarket und Tmall Supermarket zusammen.",

  // Customer Stories Section
  "stories.title": "Den Körper still unterstützen, über Jahre hinweg.",
  "stories.subtitle":
    "Wahre Qualität ist nicht Komplexität — es ist Respekt vor dem Körper und langfristige Begleitung.DR. MAGICAL strebt danach, ein wesentlicher Bestandteil des gehobenen Familien gesundheits managements weltweit zu werden.",
  "stories.successStory": "Erfolgsgeschichte",
  "stories.highlight.title": "\"Meine Familie schläft endlich wieder durch\"",
  "stories.highlight.desc":
    "Familie Schneider aus Frankfurt teilt ihre Erfahrung: Nach Jahren mit Schlafproblemen durch Mundatmung fand die ganze Familie mit DR. MAGICAL zu erholsamem Schlaf zurück. Eine Geschichte über Geduld, Vertrauen und nachhaltige Veränderung.",
  "stories.readStory": "Geschichte lesen",
  "stories.viewAll": "Alle Kundengeschichten",
  "stories.review1":
    "\"Nach nur 3 Wochen Anwendung der Mundatmungskorrektur schlafe ich viel besser. Mein Partner bemerkte sofort den Unterschied - kein Schnarchen mehr!\"",
  "stories.review1.name": "Sabine M.",
  "stories.review1.location": "München, Deutschland",
  "stories.review2":
    "\"Als Arzt schätze ich den wissenschaftlichen Ansatz von DR. MAGICAL. Die Nasenunterstützung hat meine chronischen Atemprobleme deutlich verbessert.\"",
  "stories.review2.name": "Dr. Thomas K.",
  "stories.review2.location": "Berlin, Deutschland",
  "stories.review3":
    "\"Endlich eine Lösung, die wirklich funktioniert! Die Qualität ist hervorragend und der Tragekomfort überraschend gut. Sehr empfehlenswert.\"",
  "stories.review3.name": "Lisa W.",
  "stories.review3.location": "Hamburg, Deutschland",

  // Footer
  "footer.salesChannels": "Verkaufskanäle",
  "footer.contact": "Kontakt",
  "footer.follow": "Folgen",
  "footer.copyright": "© 2018-2026 DR. MAGICAL. Alle Rechte vorbehalten.",
  "footer.privacy": "Datenschutz",
  "footer.terms": "Nutzungsbedingungen",

  // Cookie Banner
  "cookie.title": "Wir verwenden Cookies",
  "cookie.description":
    "Wir nutzen Cookies und ähnliche Technologien, um Ihre Erfahrung zu verbessern, den Datenverkehr zu analysieren und Inhalte zu personalisieren. Gemäß der EU-DSGVO benötigen wir Ihre Zustimmung für nicht notwendige Cookies.",
  "cookie.settings": "Einstellungen",
  "cookie.onlyNecessary": "Nur Notwendige",
  "cookie.acceptAll": "Alle akzeptieren",
  "cookie.settingsTitle": "Cookie-Einstellungen",
  "cookie.necessary": "Notwendige Cookies",
  "cookie.necessaryRequired": "Erforderlich",
  "cookie.necessaryDesc":
    "Diese Cookies sind für die Grundfunktionen der Website unerlässlich und können nicht deaktiviert werden.",
  "cookie.analytics": "Analyse-Cookies",
  "cookie.analyticsDesc":
    "Helfen uns zu verstehen, wie Besucher mit der Website interagieren, um die Benutzererfahrung zu verbessern.",
  "cookie.marketing": "Marketing-Cookies",
  "cookie.marketingDesc":
    "Werden verwendet, um Besuchern relevante Werbung und Marketingkampagnen anzuzeigen.",
  "cookie.functional": "Funktionale Cookies",
  "cookie.functionalDesc":
    "Ermöglichen erweiterte Funktionen und Personalisierung, wie Videos und Live-Chats.",
  "cookie.validFrom": "Gültig ab: 1. Januar 2026 | Gemäß EU-DSGVO",
  "cookie.rejectAll": "Alle ablehnen",
  "cookie.saveSettings": "Einstellungen speichern",

  // Loading
  "loading": "Laden...",

  // Language
  "language": "Sprache",
  "language.de": "Deutsch",
  "language.en": "English",

  // Products Page
  "productsPage.title": "Tägliche Pflegelösungen",
  "productsPage.subtitle":
    "Nicht-invasive Produkte für langfristige Körperausrichtung und Gesundheitsmanagement",
  "productsPage.category.mouthCare": "Mundatmungspflege",
  "productsPage.category.mouthCare.desc":
    "Sanfte Lösungen zur Unterstützung der Nasenatmung und korrekten Mundhaltung während des Schlafs und täglicher Aktivitäten.",
  "productsPage.category.nasalCare": "Nasenpflege",
  "productsPage.category.nasalCare.desc":
    "Produkte zur Optimierung des Nasenluftstroms und Unterstützung gesunder Atemmuster.",
  "productsPage.category.oralCare": "Mundpflege",
  "productsPage.category.oralCare.desc":
    "Wesentliche Werkzeuge zur Erhaltung der Mundgesundheit und Unterstützung der korrekten Kieferausrichtung.",
  "productsPage.category.sleepCare": "Schlaf- & Lärmkontrolle",
  "productsPage.category.sleepCare.desc":
    "Komfortable Lösungen für bessere Schlafqualität und ruhige Erholungsumgebungen.",
  "productsPage.exploreCategory": "Kategorie erkunden",
  "productsPage.philosophy.title": "Unsere Produktphilosophie",
  "productsPage.philosophy.desc1":
    "Jedes DR. MAGICAL Produkt wird mit demselben Kernprinzip entwickelt: die natürlichen Prozesse des Körpers unterstützen, anstatt Veränderungen zu erzwingen.",
  "productsPage.philosophy.desc2":
    "Wir konzentrieren uns auf Komfort, Diskretion und langfristige Nutzbarkeit — wir schaffen Lösungen, die mühelos Teil des täglichen Lebens werden.",
  "productsPage.principles.title": "Designprinzipien",
  "productsPage.principles.medical": "Materialien in medizinischer Qualität",
  "productsPage.principles.medical.desc":
    "Nur hochwertigste, hautverträgliche Materialien, die strengen medizinischen Standards entsprechen.",
  "productsPage.principles.comfort": "Komfort zuerst",
  "productsPage.principles.comfort.desc":
    "Entwickelt für längeres Tragen ohne Unbehagen oder Bewusstsein.",
  "productsPage.principles.discreet": "Diskretes Design",
  "productsPage.principles.discreet.desc":
    "Unsichtbar beim Tragen, damit Sie Ihre tägliche Routine natürlich beibehalten können.",
  "productsPage.cta.title": "Bereit anzufangen?",
  "productsPage.cta.desc":
    "Entdecken Sie, wo Sie DR. MAGICAL Produkte über unsere offiziellen Kanäle kaufen können.",
  "productsPage.cta.button": "Bezugsquellen",

  // Brand Philosophy Page
  "philosophyPage.label": "(Philosophie)",
  "philosophyPage.title": "Körperästhetik",
  "philosophyPage.title2": "Jenseits des Aussehens",
  "philosophyPage.intro":
    "Bei DR. MAGICAL glauben wir, dass wahre Körperästhetik nicht aggressive Transformation bedeutet, sondern das Verstehen und Respektieren der natürlichen Struktur, Haltung und Balance des Körpers.",
  "philosophyPage.core.title": "Struktur, Haltung",
  "philosophyPage.core.title2": "und tägliche Gewohnheiten",
  "philosophyPage.core.desc1":
    "Die Grundlage der Körperästhetik liegt nicht in oberflächlichen Veränderungen, sondern in der Ausrichtung der Struktur, der Qualität der Haltung und der Beständigkeit täglicher Gewohnheiten.",
  "philosophyPage.core.desc2":
    "Wir konzentrieren uns auf nicht-invasive, physikalische Korrekturmethoden, die mit den natürlichen Mechanismen des Körpers arbeiten und langfristiges Gleichgewicht unterstützen.",
  "philosophyPage.core.desc3":
    "Dieser Ansatz respektiert die Weisheit des Körpers und ermöglicht es Gesundheit und Form, sich im Laufe der Zeit natürlich zu entwickeln.",
  "philosophyPage.principles.title": "Unsere drei Kernprinzipien",
  "philosophyPage.principles.1.title": "Verstehen vor Eingreifen",
  "philosophyPage.principles.1.desc":
    "Vor jeder Korrektur priorisieren wir das Verständnis des aktuellen Zustands des Körpers, seiner strukturellen Beziehungen und der Grundursachen von Ungleichgewichten.",
  "philosophyPage.principles.2.title": "Sanfte Führung, keine Gewalt",
  "philosophyPage.principles.2.desc":
    "Unsere Produkte bieten sanfte, beständige Führung, die den Körper ermutigt, sich natürlich neu auszurichten. Wir vermeiden aggressive Methoden.",
  "philosophyPage.principles.3.title": "Langfristige Begleitung",
  "philosophyPage.principles.3.desc":
    "Wahre Veränderung braucht Zeit. Wir entwickeln für den täglichen Gebrauch über Monate und Jahre hinweg.",
  "philosophyPage.alignment.title": "Körperausrichtung ≠ Körperform",
  "philosophyPage.alignment.desc1":
    "Es geht uns nicht darum, ein bestimmtes „Aussehen\" zu erreichen oder ästhetischen Standards zu entsprechen.",
  "philosophyPage.alignment.desc2":
    "Stattdessen konzentrieren wir uns auf die strukturelle Integrität des Körpers — wie er steht, sich bewegt, atmet und im täglichen Leben funktioniert.",
  "philosophyPage.medical.title": "Eine medizinische Perspektive",
  "philosophyPage.medical.title2": "auf Körperästhetik",
  "philosophyPage.medical.desc1":
    "Gegründet von einem deutschen Arzt, bringt DR. MAGICAL klinische Strenge und wissenschaftliches Verständnis in den Bereich der Körperausrichtung.",
  "philosophyPage.medical.desc2":
    "Wir betrachten den Körper als integriertes System, in dem die Haltung die Atmung beeinflusst, die Atmung den Schlaf beeinflusst und der Schlaf die allgemeine Gesundheit beeinflusst.",
  "philosophyPage.closing.title": "Respekt. Balance. Zeit.",
  "philosophyPage.closing.desc":
    "Diese drei Worte leiden alles, was wir schaffen. Wir respektieren die Intelligenz des Körpers, unterstützen sein natürliches Gleichgewicht und verpflichten uns, langfristig dabei zu sein.",

  // Where to Buy Page
  "buyPage.title": "Bezugsquellen",
  "buyPage.subtitle":
    "Kaufen Sie authentische DR. MAGICAL Produkte über unsere offiziellen Kanäle",
  "buyPage.retailers.title": "Offizielle Einzelhandelspartner",
  "buyPage.retailers.tmall": "Tmall Global",
  "buyPage.retailers.tmall.desc":
    "Offizieller Flagship-Store mit vollständigem Produktsortiment",
  "buyPage.retailers.alibaba": "Alibaba Health Pharmacy",
  "buyPage.retailers.alibaba.desc":
    "Verifizierte Plattform für Medizin- und Gesundheitsprodukte",
  "buyPage.retailers.jd": "JD Supermarket",
  "buyPage.retailers.jd.desc":
    "Schnelle Lieferung mit Qualitätsgarantie",
  "buyPage.retailers.tmallSuper": "Tmall Supermarket",
  "buyPage.retailers.tmallSuper.desc":
    "Bequemes Einkaufen mit täglichen Bedarfsartikeln",
  "buyPage.retailers.visit": "Shop besuchen",
  "buyPage.why.title": "Warum über offizielle Kanäle kaufen",
  "buyPage.why.authentic": "Authentizität garantiert",
  "buyPage.why.authentic.desc":
    "Jedes Produkt ist echt, über offizielle Kanäle importiert mit vollständiger Compliance-Dokumentation.",
  "buyPage.why.support": "Marken-Support",
  "buyPage.why.support.desc":
    "Direkter Kundenservice und Support von DR. MAGICAL für alle Ihre Fragen und Bedürfnisse.",
  "buyPage.why.quality": "Qualitätssicherung",
  "buyPage.why.quality.desc":
    "Produkte erfüllen alle Sicherheitsstandards mit ordnungsgemäßer Qualitätskontrolle und Garantieabdeckung.",
  "buyPage.international.title": "Internationale Kunden",
  "buyPage.international.desc":
    "DR. MAGICAL konzentriert sich derzeit auf den chinesischen Markt über unsere offiziellen Partner. Für internationale Anfragen kontaktieren Sie uns bitte direkt.",
  "buyPage.international.button": "Kontaktieren Sie uns",
  "buyPage.warning.title": "Wichtiger Hinweis",
  "buyPage.warning.desc":
    "DR. MAGICAL Produkte sind nur über die auf dieser Seite aufgeführten offiziellen Kanäle erhältlich. Wir können die Authentizität oder Sicherheit von Produkten, die über nicht autorisierte Verkäufer gekauft wurden, nicht garantieren.",

  // Contact Page
  "contactPage.title": "Kontaktieren Sie uns",
  "contactPage.subtitle":
    "Wir sind hier, um Ihre Fragen zu beantworten und Sie auf Ihrem Weg zu unterstützen",
  "contactPage.form.title": "Senden Sie uns eine Nachricht",
  "contactPage.form.name": "Name",
  "contactPage.form.email": "E-Mail",
  "contactPage.form.subject": "Betreff",
  "contactPage.form.message": "Nachricht",
  "contactPage.form.maxChars": "Maximal 500 Zeichen",
  "contactPage.form.submit": "Nachricht senden",
  "contactPage.form.submitting": "Wird gesendet...",
  "contactPage.form.success":
    "Vielen Dank für Ihre Nachricht. Wir werden uns bald bei Ihnen melden.",
  "contactPage.form.error":
    "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
  "contactPage.info.title": "Kontaktdaten",
  "contactPage.info.general": "Allgemeine Anfragen",
  "contactPage.info.email": "E-Mail",
  "contactPage.info.phone": "Telefon",
  "contactPage.info.headquarters": "Hauptsitz",
  "contactPage.info.address": "Adresse",
  "contactPage.info.addressValue": "Medizinisches Innovationszentrum",
  "contactPage.info.hours": "Geschäftszeiten",
  "contactPage.info.hoursLabel": "Montag - Freitag",
  "contactPage.info.hoursValue": "9:00 - 18:00 Uhr (MEZ)",
  "contactPage.info.follow": "Folgen Sie uns",
  "contactPage.faq.title": "Häufig gestellte Fragen",
  "contactPage.faq.q1": "Wo kann ich DR. MAGICAL Produkte kaufen?",
  "contactPage.faq.a1":
    "Unsere Produkte sind über offizielle Kanäle erhältlich, darunter Tmall Global, Alibaba Health Pharmacy, JD Supermarket und Tmall Supermarket.",
  "contactPage.faq.q2": "Sind Ihre Produkte für die langfristige Nutzung geeignet?",
  "contactPage.faq.a2":
    "Ja, alle DR. MAGICAL Produkte sind für die konsequente, langfristige Nutzung konzipiert. Sie bestehen aus Materialien in medizinischer Qualität.",
  "contactPage.faq.q3": "Liefern Sie international?",
  "contactPage.faq.a3":
    "Derzeit konzentrieren wir uns auf den chinesischen Markt über unsere offiziellen Einzelhandelspartner. Für internationale Anfragen kontaktieren Sie uns bitte direkt.",
  "contactPage.faq.q4": "Wie kann ich die Produktauthentizität überprüfen?",
  "contactPage.faq.a4":
    "Kaufen Sie nur über unsere offiziellen Kanäle. Alle authentischen Produkte werden mit ordnungsgemäßer Verpackung und Dokumentation geliefert.",

  // Journal Page
  "journalPage.title": "Journal",
  "journalPage.subtitle":
    "Einblicke in Körperausrichtung, Gesundheit und Wohlbefinden",
  "journalPage.readArticle": "Artikel lesen",
  "journalPage.recentArticles": "Aktuelle Artikel",
  "journalPage.readMore": "Mehr lesen →",
  "journalPage.exploreTopics": "Nach Thema erkunden",
  "journalPage.topics.alignment": "Körperausrichtung",
  "journalPage.topics.breathing": "Atemgesundheit",
  "journalPage.topics.wellness": "Tägliches Wohlbefinden",
  "journalPage.topics.research": "Medizinische Forschung",
  "journalPage.article1.title":
    "Körperausrichtung verstehen: Eine medizinische Perspektive",
  "journalPage.article1.excerpt":
    "Erforschung der Beziehung zwischen Haltung, Atmung und allgemeiner Gesundheit aus der Sicht der medizinischen Wissenschaft.",
  "journalPage.article1.category": "Körperausrichtung",
  "journalPage.article1.date": "15. Dezember 2024",
  "journalPage.article2.title": "Mundatmung und moderner Lebensstil",
  "journalPage.article2.excerpt":
    "Wie zeitgenössische Gewohnheiten Atemmuster beeinflussen und was wir tun können, um natürliche Nasenatmung zu unterstützen.",
  "journalPage.article2.category": "Atemgesundheit",
  "journalPage.article2.date": "10. Dezember 2024",
  "journalPage.article3.title":
    "Haltung, Schlaf und tägliche Gewohnheiten",
  "journalPage.article3.excerpt":
    "Die vernetzte Beziehung zwischen wie wir sitzen, stehen, schlafen und unseren langfristigen Gesundheitsergebnissen.",
  "journalPage.article3.category": "Tägliches Wohlbefinden",
  "journalPage.article3.date": "5. Dezember 2024",
  "journalPage.article4.title":
    "Die Wissenschaft der nicht-invasiven Körperunterstützung",
  "journalPage.article4.excerpt":
    "Warum sanfte, beständige Unterstützung oft bessere langfristige Ergebnisse erzielt als aggressive Eingriffe.",
  "journalPage.article4.category": "Medizinische Forschung",
  "journalPage.article4.date": "28. November 2024",
  "journalPage.article5.title":
    "Deutsche Ingenieurskunst trifft medizinische Wissenschaft",
  "journalPage.article5.excerpt":
    "Wie Präzisionsfertigung und medizinisches Wissen zusammenkommen, um effektive Gesundheitsprodukte zu schaffen.",
  "journalPage.article5.category": "Design & Innovation",
  "journalPage.article5.date": "20. November 2024",

  // Customer Stories Page
  "storiesPage.label": "(Kundenstimmen)",
  "storiesPage.title": "Echte Geschichten,",
  "storiesPage.title2": "echte Veränderungen",
  "storiesPage.subtitle":
    "Entdecken Sie, wie DR. MAGICAL das Leben unserer Kunden positiv beeinflusst hat. Jede Geschichte ist ein Zeugnis für die Kraft sanfter, nicht-invasiver Körperpflege.",
  "storiesPage.stats.satisfaction": "Kundenzufriedenheit",
  "storiesPage.stats.customers": "Zufriedene Kunden",
  "storiesPage.stats.rating": "Durchschnittsbewertung",
  "storiesPage.stats.recommendation": "Weiterempfehlungsrate",
  "storiesPage.featured.title": "Ausgewählte Erfolgsgeschichten",
  "storiesPage.featured.subtitle": "Tiefgehende Einblicke in die Erfahrungen unserer Kunden",
  "storiesPage.all.title": "Alle Kundengeschichten",
  "storiesPage.all.subtitle": "Filtern Sie nach Produktkategorie",
  "storiesPage.filter.all": "Alle",
  "storiesPage.filter.mouth": "Mundatmung",
  "storiesPage.filter.nasal": "Nasenunterstützung",
  "storiesPage.filter.sleep": "Schlafmanagement",
  "storiesPage.reviews.title": "Was unsere Kunden sagen",
  "storiesPage.reviews.subtitle": "Kurze Bewertungen von verifizierten Käufern",
  "storiesPage.cta.title": "Bereit für Ihre eigene Erfolgsgeschichte?",
  "storiesPage.cta.subtitle":
    "Entdecken Sie unsere Produkte und beginnen Sie Ihre Reise zu besserem Schlaf und mehr Wohlbefinden.",
  "storiesPage.cta.products": "Produkte entdecken",
  "storiesPage.cta.contact": "Kontakt aufnehmen",
  "storiesPage.successStory": "Erfolgsgeschichte",
  "storiesPage.usage": "Nutzung",
  "storiesPage.readFull": "Vollständige Geschichte lesen",
  "storiesPage.showLess": "Weniger anzeigen",
  "storiesPage.readStory": "Geschichte lesen",
  "storiesPage.close": "Schließen",
  "storiesPage.product": "Produkt",

  // German Medical Origin Page
  "originPage.label": "(Ursprungsgeschichte)",
  "originPage.title": "Medizinische Einsicht,",
  "originPage.title2": "Deutsche Präzision",
  "originPage.intro":
    "Gegründet 2018 von einem deutschen Arzt, entstand DR. MAGICAL aus langjähriger Forschung über die Beziehung zwischen Körperstruktur, Haltung und Gesundheit.",
  "originPage.founder.title": "Von klinischer Forschung",
  "originPage.founder.title2": "zu täglichen Lösungen",
  "originPage.founder.desc1":
    "Der Gründer, ein praktizierender Arzt in Deutschland, beobachtete jahrelang, wie moderne Lebensgewohnheiten — langes Sitzen, Bildschirmzeit, Mundatmung — weit verbreitete Haltungs- und Strukturprobleme verursachten.",
  "originPage.founder.desc2":
    "Diese Probleme wurden von der traditionellen Medizin nicht angegangen, die sich auf die Behandlung von Symptomen konzentrierte, anstatt die natürliche Ausrichtung des Körpers zu unterstützen.",
  "originPage.founder.desc3":
    "DR. MAGICAL entstand aus der Überzeugung, dass medizinisches Wissen in praktische,tragbare Lösungen für den Alltag übersetzt werden kann.",
  "originPage.tradition.title": "Verwurzelt in deutscher medizinischer Tradition",
  "originPage.tradition.evidence": "Evidenzbasierter Ansatz",
  "originPage.tradition.evidence.desc":
    "Jedes Produkt wird auf der Grundlage anatomischen Verständnisses, klinischer Beobachtung und strenger Tests entwickelt.",
  "originPage.tradition.precision": "Ingenieurs-Präzision",
  "originPage.tradition.precision.desc":
    "Deutsche Ingenieurdisziplin stellt sicher, dass jedes Detail höchsten Qualitäts- und Funktionalitätsstandards entspricht.",
  "originPage.tradition.safety": "Sicherheit zuerst",
  "originPage.tradition.safety.desc":
    "Alle Produkte durchlaufen gründliche Sicherheitstests und entsprechen den Standards für Medizinprodukte.",
  "originPage.tradition.longterm": "Langfristiges Denken",
  "originPage.tradition.longterm.desc":
    "Wir entwickeln für Langlebigkeit und nachhaltige Nutzung, nicht für Wegwerfkonsum.",
  "originPage.research.title": "Forschungsbereiche",
  "originPage.research.title2": "und Expertise",
  "originPage.research.structure": "Körperstruktur & Haltung",
  "originPage.research.structure.desc":
    "Verstehen, wie Skelettausrichtung, Muskelspannung und tägliche Gewohnheiten interagieren.",
  "originPage.research.breathing": "Atemmuster",
  "originPage.research.breathing.desc":
    "Erforschung der Auswirkungen von Mundatmung versus Nasenatmung auf die Gesichtsentwicklung und Schlafqualität.",
  "originPage.research.sleep": "Schlaf & Erholung",
  "originPage.research.sleep.desc":
    "Erforschung, wie Körperposition, Atmung und Umweltfaktoren die Schlafqualität beeinflussen.",
  "originPage.research.materials": "Materialwissenschaft",
  "originPage.research.materials.desc":
    "Entwicklung von Materialien in medizinischer Qualität für den langfristigen täglichen Gebrauch.",
  "originPage.manufacturing.title": "Qualität & Fertigung",
  "originPage.manufacturing.desc":
    "Alle DR. MAGICAL Produkte werden in Einrichtungen hergestellt, die europäischen Medizinproduktstandards entsprechen.",
  "originPage.manufacturing.quality": "Medizinische Qualität",
  "originPage.manufacturing.certified": "Zertifiziert",
  "originPage.manufacturing.years": "Jahre Forschung",
  "originPage.global.title": "Von Deutschland in die Welt",
  "originPage.global.desc1":
    "Seit dem Eintritt in den chinesischen Markt im Jahr 2020 arbeitet DR. MAGICAL mit führenden E-Commerce-Plattformen zusammen, darunter Tmall Global, Alibaba Health Pharmacy, JD Supermarket und Tmall Supermarket.",
  "originPage.global.desc2":
    "Unsere Vision ist es, ein vertrauenswürdiger Teil des gehobenen Familiengesundheitsmanagements weltweit zu werden.",
  "originPage.closing.title": "Medizinisches Wissen,",
  "originPage.closing.title2": "Tägliche Anwendung",
  "originPage.closing.desc":
    "Das ist die Essenz von DR. MAGICAL — klinische Erkenntnisse in praktische Lösungen zu übersetzen, die das natürliche Gleichgewicht des Körpers jeden Tag unterstützen.",

  // Science & Design Page
  "sciencePage.title": "Wissenschaft & Design",
  "sciencePage.subtitle": "Wo medizinisches Wissen auf Präzisionstechnik trifft",
  "sciencePage.philosophy.title": "Unsere Designphilosophie",
  "sciencePage.philosophy.desc1": "Jedes DR. MAGICAL Produkt beginnt mit einer medizinischen Frage: Wie können wir die natürlichen Prozesse des Körpers ohne Eingriff oder Zwang unterstützen?",
  "sciencePage.philosophy.desc2": "Auf dieser Grundlage wenden wir deutsche Ingenieursprinzipien an — Präzision, Langlebigkeit und funktionale Eleganz — um Lösungen zu schaffen, die nahtlos mit dem täglichen Leben funktionieren.",
  "sciencePage.philosophy.desc3": "Das Ergebnis sind Produkte, die sich beim Tragen unsichtbar anfühlen, aber über Monate und Jahre hinweg beständige, sanfte Unterstützung bieten.",
  "sciencePage.principles.title": "Kern-Designprinzipien",
  "sciencePage.principles.medical.title": "Medizinische Grundlage",
  "sciencePage.principles.medical.desc": "Jede Designentscheidung basiert auf medizinischer Forschung und klinischem Verständnis der Körpermechanik.",
  "sciencePage.principles.precision.title": "Präzisionstechnik",
  "sciencePage.principles.precision.desc": "Deutsche Fertigungsstandards gewährleisten konsistente Qualität und exakte Spezifikationen bei jedem Produkt.",
  "sciencePage.principles.human.title": "Menschenzentriert",
  "sciencePage.principles.human.desc": "Komfort und Benutzerfreundlichkeit leiden jede Iteration und stellen sicher, dass Produkte sich natürlich in den Alltag integrieren.",
  "sciencePage.materials.title": "Materialauswahl",
  "sciencePage.materials.medical.title": "Standards in medizinischer Qualität",
  "sciencePage.materials.medical.desc1": "Alle Materialien erfüllen strenge Medizinproduktstandards für Biokompatibilität, Sicherheit und hypoallergene Eigenschaften.",
  "sciencePage.materials.medical.desc2": "Wir priorisieren Materialien mit bewährter Erfolgsbilanz in medizinischen Anwendungen und gewährleisten Sicherheit bei langfristigem Hautkontakt.",
  "sciencePage.materials.comfort.title": "Komfort & Langlebigkeit",
  "sciencePage.materials.comfort.desc1": "Materialien werden nicht nur nach Sicherheit ausgewählt, sondern auch nach ihrer Fähigkeit, Komfort und Leistung bei längerer Nutzung zu erhalten.",
  "sciencePage.materials.comfort.desc2": "Atmungsaktivität, Flexibilität und Widerstandsfähigkeit werden sorgfältig ausbalanciert, um Produkte zu schaffen, die sich natürlich anfühlen.",
  "sciencePage.materials.environment.title": "Umweltbewusstsein",
  "sciencePage.materials.environment.desc1": "Wo möglich, wählen wir Materialien mit geringerer Umweltbelastung, ohne medizinische Standards zu kompromittieren.",
  "sciencePage.materials.environment.desc2": "Langlebigkeit selbst ist eine Umweltentscheidung — Produkte, die länger halten, reduzieren Abfall und Ressourcenverbrauch.",
  "sciencePage.materials.testing.title": "Kontinuierliche Tests",
  "sciencePage.materials.testing.desc1": "Materialien durchlaufen strenge Tests auf Hautverträglichkeit, Verschleißfestigkeit und Leistungskonsistenz.",
  "sciencePage.materials.testing.desc2": "Wir halten strenge Qualitätskontrollen in der gesamten Lieferkette aufrecht, um sicherzustellen, dass jedes Produkt unseren Standards entspricht.",
  "sciencePage.process.title": "Entwicklungsprozess",
  "sciencePage.process.step1.title": "Medizinische Forschung",
  "sciencePage.process.step1.desc": "Wir beginnen damit, eine spezifische Herausforderung der Körperausrichtung durch klinische Beobachtung und Literaturrecherche zu identifizieren. Dies bildet die wissenschaftliche Grundlage für das Produkt.",
  "sciencePage.process.step2.title": "Konzeptentwicklung",
  "sciencePage.process.step2.desc": "Unser Designteam übersetzt medizinische Anforderungen in physische Konzepte und erforscht Materialien, Strukturen und Mechanismen, die die benötigte Unterstützung bieten können.",
  "sciencePage.process.step3.title": "Prototyping & Tests",
  "sciencePage.process.step3.desc": "Mehrere Prototypen werden erstellt und auf Komfort, Wirksamkeit und Langlebigkeit getestet. Benutzerfeedback leitet iterative Verbesserungen, bis das Design alle Anforderungen erfüllt.",
  "sciencePage.process.step4.title": "Fertigungsoptimierung",
  "sciencePage.process.step4.desc": "Produktionsprozesse werden optimiert, um konsistente Qualität in großem Maßstab zu gewährleisten, mit strengen Qualitätskontrollen in jeder Phase.",
  "sciencePage.process.step5.title": "Kontinuierliche Verbesserung",
  "sciencePage.process.step5.desc": "Auch nach der Markteinführung sammeln wir Benutzerfeedback und überwachen die Leistung, um Verbesserungsmöglichkeiten für zukünftige Versionen zu identifizieren.",
  "sciencePage.detail.title": "Liebe zum Detail",
  "sciencePage.detail.desc1": "Die deutsche Designtradition betont, dass jedes Detail zählt. Vom Radius einer Kurve bis zur Textur einer Oberfläche wird jedes Element auf seine Auswirkung auf Funktion und Komfort hin betrachtet.",
  "sciencePage.detail.desc2": "Dieser akribischen Ansatz bedeutet, dass unsere Produkte oft einfach erscheinen, aber diese Einfachheit ist das Ergebnis unzähliger Verfeinerungen, um alles Unnötige zu eliminieren.",
  "sciencePage.detail.desc3": "Das Ziel sind Produkte, die sich intuitiv bedienen lassen, keine Lernkurve erfordern und sich nahtlos in den Alltag integrieren.",
  "sciencePage.cta.title": "Erleben Sie den Unterschied",
  "sciencePage.cta.desc": "Entdecken Sie, wie medizinische Wissenschaft und Präzisionsdesign in Produkten zusammenkommen, die das natürliche Gleichgewicht Ihres Körpers unterstützen.",
  "sciencePage.cta.button": "Produkte erkunden",
};

export default common;
